const Vue = require('vue')
import vuet from '@/vuet'
import App from './App'
import router from '@/router'
import config from '@/util/config'

if (config.wx.isWXMini) {

  var vs = window.location.href.split("#");
  if (vs.length > 1 && vs[1]) {
    config.setToken(vs[1]);
    config.userinfo.token = '';
  } else {
    config.clearUserInfo();
  }
}
//
import '!style-loader!css-loader!less-loader!@/assets/common.less';
// import '!style-loader!css-loader!less-loader!@/assets/vant.less';
// import '!style-loader!css-loader!less-loader!@/assets/button.less';


// const _ = require('lodash')
import Vuelidate from 'vuelidate'

import VuetScroll from 'vuet-scroll'


const moment = require('moment')
import "moment/locale/zh-cn";
moment.locale('zh_cn');

import VueMomentJS from 'vue-momentjs'
Vue.use(VueMomentJS, moment)

Vue.use(Vuelidate)
Vue.use(VuetScroll)

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

import {
  VueHammer
} from 'vue2-hammer'
Vue.use(VueHammer)

VueHammer.config.swipe = {
  // direction: 'all'
};


import {
  Toast,
  Row,
  Col,
  Cascader,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Step,
  Steps,
  Badge,
  Rate,
  Switch,
  Overlay,
  Collapse,
  CollapseItem,
  Dialog,
  NavBar,
  Swipe,
  SwipeItem,
  Icon,
  Panel,
  Grid,
  GridItem,
  Tabbar,
  TabbarItem,
  Field,
  Button,
  Uploader,
  TreeSelect,
  Image,
  Card,
  Sticky,
  Popup,
  SubmitBar,
  Cell,
  CellGroup,
  Stepper,
  Tag,
  PullRefresh,
  List,
  Tab,
  Tabs,
  DatetimePicker,
  RadioGroup,
  Radio,
  Search,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  CheckboxGroup,
  IndexBar,
  IndexAnchor,
  Progress,
  Picker,
  Loading,
  Lazyload,
  ImagePreview,
  Skeleton,
  Calendar,
  ActionSheet,
  Empty,
  Notify,
  ShareSheet,
  NoticeBar,
  CountDown,
  Slider,
  Divider,
  Popover
} from 'vant'
Vue
  .use(Toast)
  .use(Row)
  .use(Col)
  .use(Cascader)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Step)
  .use(Steps)
  .use(Badge)
  .use(Divider)
  .use(Slider)
  .use(CountDown)
  .use(NoticeBar)
  .use(ShareSheet)
  .use(Rate)
  .use(Switch)
  .use(Notify)
  .use(Empty)
  .use(ActionSheet)
  .use(Calendar)
  .use(Skeleton)
  .use(ImagePreview)
  .use(Lazyload)
  .use(Loading)
  .use(Picker)
  .use(Progress)
  .use(Overlay)
  .use(Collapse)
  .use(CollapseItem)
  .use(Dialog)
  .use(IndexAnchor)
  .use(IndexBar)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(RadioGroup)
  .use(Radio)
  .use(NavBar)
  .use(Swipe)
  .use(SwipeItem)
  .use(Icon)
  .use(Panel)
  .use(Grid)
  .use(GridItem)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(TreeSelect)
  .use(Image)
  .use(Card)
  .use(Sticky)
  .use(Popup)
  .use(SubmitBar)
  .use(Cell)
  .use(CellGroup)
  .use(Stepper)
  .use(Tag)
  .use(PullRefresh)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(DatetimePicker)
  .use(Search)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popover);

(function () {
  var initFontSize = 16
  var iPhone6Width = 375
  var clientWidth = window.document.documentElement.clientWidth || iPhone6Width
  var newFontSize = initFontSize * (clientWidth / iPhone6Width)
  if (newFontSize > 30) {
    newFontSize = 30;
  }
  document.documentElement.style.fontSize = newFontSize + 'px'
})()


Vue.config.productionTip = false

new Vue({
  router,
  vuet,
  render: h => h(App)
}).$mount('#app')
